var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 879,
    viewBox: "0 0 880 879",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.567 366.245C238.567 254.997 328.756 164.808 440.005 164.808C551.253 164.808 641.442 254.997 641.442 366.245C641.442 477.494 551.253 567.683 440.005 567.683C328.756 567.683 238.567 477.494 238.567 366.245Z",
    fill: "url(#paint0_linear_64_29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.192 629.78C665.761 582.223 733.005 482.09 733.005 366.245C733.005 204.418 601.832 73.2451 440.005 73.2451C278.196 73.2451 147.005 204.418 147.005 366.245C147.005 482.108 214.248 582.259 311.836 629.799V787.433C311.835 790.748 312.735 794.001 314.438 796.845C316.142 799.69 318.586 802.018 321.509 803.582C324.432 805.146 327.725 805.887 331.037 805.726C334.348 805.565 337.554 804.509 340.312 802.669L440.005 736.194L539.716 802.669C542.474 804.509 545.68 805.565 548.991 805.726C552.303 805.887 555.596 805.146 558.519 803.582C561.442 802.018 563.886 799.69 565.59 796.845C567.293 794.001 568.193 790.748 568.192 787.433V629.78ZM440.005 622.62C581.597 622.62 696.38 507.837 696.38 366.245C696.38 224.653 581.597 109.87 440.005 109.87C298.413 109.87 183.63 224.653 183.63 366.245C183.63 507.837 298.413 622.62 440.005 622.62Z",
    fill: "url(#paint1_linear_64_29)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_29",
    x1: 128.403,
    y1: 147.184,
    x2: 371.601,
    y2: 451.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520674,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_29",
    x1: -13.2339,
    y1: 41.2027,
    x2: 440,
    y2: 494.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520674,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.38f033c8d1c32e8e0510909169ccd1e6.svg";
export { ForwardRef as ReactComponent };